import * as React from 'react';

import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { unstable_useId as useId } from '@mui/material/utils';

import styles from './SwitchField.module.css';

export interface SwitchFieldProps {
  label: string;
  description?: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Explains why the switch is disabled. */
  disabledReason?: string;
}

/** A switch with a label and a one-line explanation underneath. */
const SwitchField: React.FC<SwitchFieldProps> = ({
  label,
  description,
  checked,
  onChange,
  disabled,
  disabledReason,
}) => {
  const descriptionId = useId();
  const help = disabled && disabledReason ? disabledReason : description;
  return (
    <Box className={styles.field}>
      <FormControlLabel
        className={styles.label}
        control={
          <Switch
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
            inputProps={{ 'aria-describedby': help ? descriptionId : undefined }}
          />
        }
        label={label}
      />
      {help && (
        <Typography
          id={descriptionId}
          variant="caption"
          color="text.secondary"
          className={styles.description}
        >
          {help}
        </Typography>
      )}
    </Box>
  );
};

export default SwitchField;
